export default "__VITE_ASSET__C_th2cnH__"